import React from 'react';
import './SessionList.css';

const SessionList = ({ sessions, onSelect, selectedId }) => {
  if (!sessions || sessions.length === 0) {
    return <p className="empty-message">No sessions available.</p>;
  }

  return (
    <div className="session-list-container">
      <h3>🗂 Session List</h3>
      <ul className="session-list">
        {sessions.map((session) => (
          <li
            key={session.id}
            className={`session-item ${selectedId === session.id ? 'active' : ''}`}
            onClick={() => onSelect(session)}
          >
            <div className="session-meta">
              <strong>Session #{session.id}</strong>
              <span>{session.messages?.length || 0} msgs</span>
            </div>
            <div className="session-snippet">
              {session.messages?.[0]?.text?.slice(0, 50)}...
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SessionList;
